var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for authority record operations.
 */
import { getHeaders } from './apiUtils';
import { API_PATHS, CZNA_AUTHORITIES_RECORD_DETAIL, CZNA_AUTHORITIES_RECORD_EXPORT, CZNA_AUTHORITIES_RECORD_HISTORY, CZNA_AUTHORITIES_RECORD_MERGE, CZNA_AUTHORITIES_RECORD_MERGE_PREVIEW, CZNA_AUTHORITIES_RECORD_REFERENCES_COUNT, CZNA_AUTHORITIES_RECORD_REVIEW, CZNA_AUTHORITIES_RECORD_SKOS, CZNA_AUTHORITIES_RECORDS_INDEX_GROUP, } from '../types/apiPaths';
import { parseBlockingRefsError } from '../utils/parseBlockingRefsError';
import { recordDisplayId } from '../utils/recordDisplayId';
var DEFAULT_LIMIT = 50;
/**
 * Builds URLSearchParams from record search parameters.
 * Skips null/undefined values so the backend uses its defaults.
 */
export var buildSearchParams = function (params) {
    var searchParams = new URLSearchParams();
    if (params.query) {
        searchParams.set('query', params.query);
    }
    if (params.type) {
        searchParams.set('type', params.type);
    }
    if (params.sourceSystem) {
        searchParams.set('sourceSystem', params.sourceSystem);
    }
    if (params.status) {
        searchParams.set('status', params.status);
    }
    if (params.sortBy) {
        searchParams.set('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
        searchParams.set('sortOrder', params.sortOrder);
    }
    if (params.afterSortValue) {
        searchParams.set('afterSortValue', params.afterSortValue);
    }
    if (params.afterId) {
        searchParams.set('afterId', params.afterId);
    }
    if (params.beforeSortValue) {
        searchParams.set('beforeSortValue', params.beforeSortValue);
    }
    if (params.beforeId) {
        searchParams.set('beforeId', params.beforeId);
    }
    if (params.limit !== undefined && params.limit !== null) {
        searchParams.set('limit', params.limit.toString());
    }
    if (params.createdFrom) {
        searchParams.set('createdFrom', params.createdFrom);
    }
    if (params.createdTo) {
        searchParams.set('createdTo', params.createdTo);
    }
    if (params.updatedFrom) {
        searchParams.set('updatedFrom', params.updatedFrom);
    }
    if (params.updatedTo) {
        searchParams.set('updatedTo', params.updatedTo);
    }
    if (params.createdBy) {
        searchParams.set('createdBy', params.createdBy);
    }
    if (params.includeTotalCount) {
        searchParams.set('includeTotalCount', 'true');
    }
    if (params.includeExportEligibility) {
        searchParams.set('includeExportEligibility', 'true');
    }
    if (params.offset !== undefined && params.offset !== null) {
        searchParams.set('offset', params.offset.toString());
    }
    if (params.searchMode) {
        searchParams.set('searchMode', params.searchMode);
    }
    if (params.reviewStatus) {
        searchParams.set('reviewStatus', params.reviewStatus);
    }
    // TASK-159: repeating validationStatus param → OR semantics server-side.
    // URLSearchParams.append (not set) preserves multiplicity, matching the API
    // contract `?validationStatus=A&validationStatus=B`.
    if (params.validationStatus && params.validationStatus.length > 0) {
        params.validationStatus.forEach(function (v) { return searchParams.append('validationStatus', v); });
    }
    // CZNA-330 (AV-03 drill-down): single issue-code filter.
    if (params.issueCode) {
        searchParams.set('issueCode', params.issueCode);
    }
    // CZNA-974 — without this, useRecordList's includeProposals: true never reaches the
    // backend and the combined record+proposal search never activates.
    if (params.includeProposals) {
        searchParams.set('includeProposals', 'true');
    }
    // CZNA-217 — the query line's condition tree; the export reuses this builder, which is
    // what keeps the list, Export CSV and Export MARC on one result set.
    if (params.fieldQuery) {
        searchParams.set('fieldQuery', params.fieldQuery);
    }
    // CZNA-1648 — only the opt-out travels; the backend searches the links by default.
    if (params.includeRelated === false) {
        searchParams.set('includeRelated', 'false');
    }
    return searchParams;
};
/**
 * Fetches authority records with optional search, filtering, sorting and pagination.
 */
export var fetchRecords = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var defaults, mergedParams, searchParams;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_a) {
            defaults = {
                status: 'active',
                sortBy: 'updatedAt',
                sortOrder: 'desc',
                limit: DEFAULT_LIMIT,
            };
            mergedParams = __assign(__assign({}, defaults), params);
            searchParams = buildSearchParams(mergedParams);
            return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS, "?").concat(searchParams), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * CZNA-216 — builds query params for the alphabetical heading index.
 * Skips undefined values so the backend applies its defaults.
 */
export var buildIndexParams = function (params) {
    var searchParams = new URLSearchParams();
    // CZNA-230: omit recordType from the query for the untyped (all-types) register.
    if (params.recordType !== undefined) {
        searchParams.set('recordType', params.recordType);
    }
    if (params.anchor !== undefined && params.anchor !== '') {
        searchParams.set('anchor', params.anchor);
    }
    // CZNA-230: keyset tie-breaker — only meaningful alongside an anchor value.
    if (params.anchorId !== undefined && params.anchor !== undefined && params.anchor !== '') {
        searchParams.set('anchorId', params.anchorId.toString());
    }
    if (params.after !== undefined) {
        searchParams.set('after', params.after.toString());
    }
    if (params.before !== undefined) {
        searchParams.set('before', params.before.toString());
    }
    // CZNA-1168: omit for the unfiltered register.
    if (params.language) {
        searchParams.set('language', params.language);
    }
    // CZNA-1379: omit for active records, the backend's default.
    if (params.status && params.status !== 'active') {
        searchParams.set('status', params.status);
    }
    if (params.pickable) {
        searchParams.set('pickable', 'true');
    }
    return searchParams;
};
/**
 * CZNA-216 — fetches a window of the alphabetical heading register (rejstřík).
 * One row per heading (PREFERRED + VARIANT), ordered by Czech collation.
 */
export var fetchRecordIndex = function (ky, params) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams;
    return __generator(this, function (_a) {
        searchParams = buildIndexParams(params);
        return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS_INDEX, "?").concat(searchParams), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-1168 — languages of the register's VARIANT headings (from `4XX $2`) with counts,
 * most frequent first, for the "Jazyk" filter. `recordType` scopes it to the register
 * type in force, so the filter never offers a language the selected type does not have.
 */
export var fetchIndexLanguages = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, opts) {
        var path;
        if (opts === void 0) { opts = {}; }
        return __generator(this, function (_a) {
            path = opts.recordType
                ? "".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS_INDEX_LANGUAGES, "?recordType=").concat(encodeURIComponent(opts.recordType))
                : API_PATHS.CZNA_AUTHORITIES_RECORDS_INDEX_LANGUAGES;
            return [2 /*return*/, ky.get(path, {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * CZNA-1513 — the records behind one register row. The row's own filters go along, so
 * the list holds exactly the records its count counted; both are omitted at their default.
 */
export var fetchRecordIndexGroup = function (ky_1, headingId_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1, headingId_1], args_1, true), void 0, function (ky, headingId, opts) {
        var searchParams, query, path;
        if (opts === void 0) { opts = {}; }
        return __generator(this, function (_a) {
            searchParams = new URLSearchParams();
            if (opts.language) {
                searchParams.set('language', opts.language);
            }
            if (opts.status && opts.status !== 'active') {
                searchParams.set('status', opts.status);
            }
            query = searchParams.toString();
            path = CZNA_AUTHORITIES_RECORDS_INDEX_GROUP(headingId);
            return [2 /*return*/, ky.get(query ? "".concat(path, "?").concat(query) : path, {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * DB-061 — the source systems present in the corpus (distinct `source_system` over
 * active records, sorted ascending), for the "Zdrojový systém" sidebar filter.
 *
 * <p>`type` scopes the facet to the SAME slice the list is showing, because the two
 * predicates have to agree or the filter offers dead options. Measured: DERIVED (1 549
 * active records) and SEED (743) are 100 % `VOCABULARY_*` typed, and the default list
 * view excludes vocabulary types — so an unscoped facet offers DERIVED, and picking it
 * empties the grid. That is the very defect this endpoint exists to remove. Omitting
 * `type` mirrors the list's own default (vocabulary types excluded).
 *
 * <p>Deliberately not cached beyond react-query's own default: the endpoint is cheap
 * (a loose index scan) and its whole point is to notice a source system an import has
 * just introduced — which is exactly when a longer-lived cache would still be serving
 * the old answer.
 */
export var fetchSourceSystems = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, opts) {
        var path;
        if (opts === void 0) { opts = {}; }
        return __generator(this, function (_a) {
            path = opts.type
                ? "".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS_SOURCE_SYSTEMS, "?type=").concat(encodeURIComponent(opts.type))
                : API_PATHS.CZNA_AUTHORITIES_RECORDS_SOURCE_SYSTEMS;
            return [2 /*return*/, ky.get(path, {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * Extension and `format` query value per format. The value is sent VERBATIM and in upper
 * case because Spring's enum binding for query parameters is case-sensitive — `marcxml`
 * answers 400 `No enum constant …`, as every other enum parameter on this API does.
 */
var EXPORT_FILE = {
    CSV: { extension: 'csv' },
    MARCXML: { extension: 'xml' },
};
/**
 * Hands a downloaded body to the browser as a file named `fileName`. Shared by the list's
 * export and the record detail's (CZNA-1617), so both save a file the same way.
 */
var saveResponseAs = function (response, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var blob, url, a;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, response.blob()];
            case 1:
                blob = _a.sent();
                url = window.URL.createObjectURL(blob);
                try {
                    a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                finally {
                    window.URL.revokeObjectURL(url);
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * Exports authority records based on the current search/filter parameters and triggers a
 * browser download.
 *
 * <p>`format` defaults to CSV so every existing caller keeps the file it used to get.
 */
export var fetchRecordExport = function (ky_1, params_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1, params_1], args_1, true), void 0, function (ky, params, format) {
        var searchParams, query, response;
        if (format === void 0) { format = 'CSV'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchParams = buildSearchParams(params);
                    query = format === 'CSV' ? "".concat(searchParams) : "".concat(searchParams, "&format=").concat(format);
                    return [4 /*yield*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS_EXPORT, "?").concat(query), {
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, saveResponseAs(response, "authority-records-export.".concat(EXPORT_FILE[format].extension))];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
/**
 * CZNA-1617 — the name the detail's MARCXML export is saved under: the identifier the detail
 * shows (`recordDisplayId` — the control number, e.g. `jx20050120001.xml`, or a vocabulary
 * row's authority id). Anything outside `[A-Za-z0-9._-]` becomes `_`, so an identifier can
 * neither name a path nor carry a character a file system refuses.
 */
export var singleRecordExportFileName = function (record) {
    var displayId = recordDisplayId(record);
    return displayId
        ? "".concat(displayId.replace(/[^A-Za-z0-9._-]/g, '_'), ".xml")
        : 'authority-record-export.xml';
};
/**
 * CZNA-1617 (UC AR-04) — downloads the round-trip MARCXML of ONE record, the file the list's
 * MARC export produces for a filter that matches only it (the server writes both with the
 * same exporter). A failed request rejects, so the caller can say so.
 */
export var fetchSingleRecordExport = function (ky, record) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get(CZNA_AUTHORITIES_RECORD_EXPORT(record.id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, saveResponseAs(response, singleRecordExportFileName(record))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
/** CZNA-217 — the fields and subfields the query line can address. */
export var fetchFieldQueryCatalog = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(API_PATHS.CZNA_AUTHORITIES_RECORDS_FIELD_QUERY_FIELDS, {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-217 — the most frequent stored values of one field/subfield that start with
 * `prefix`, for the query line's value suggestions.
 */
export var fetchFieldValues = function (ky, params) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams;
    return __generator(this, function (_a) {
        searchParams = new URLSearchParams({ field: params.field, prefix: params.prefix });
        if (params.subfield) {
            searchParams.set('subfield', params.subfield);
        }
        if (params.limit !== undefined) {
            searchParams.set('limit', String(params.limit));
        }
        return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS_FIELD_VALUES, "?").concat(searchParams), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Fetches a single authority record by ID.
 */
export var fetchRecord = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS, "/").concat(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/** IANA media type advertised in the Accept header per SKOS format. */
var SKOS_ACCEPT = {
    turtle: 'text/turtle',
    jsonld: 'application/ld+json',
    rdfxml: 'application/rdf+xml',
};
/**
 * CZNA-193 (TASK-150) — fetches a single authority record rendered as SKOS
 * linked data in the requested RDF syntax. The endpoint returns a raw RDF
 * document (text/turtle | application/ld+json | application/rdf+xml), so the
 * body is read as text rather than parsed as JSON. The format is selected via
 * the `?format=` query parameter; an `Accept` header is also sent so the
 * request advertises the expected media type (the default JSON content-type is
 * dropped — this is a body-less GET).
 */
export var getSkos = function (ky_1, id_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1, id_1], args_1, true), void 0, function (ky, id, format) {
        if (format === void 0) { format = 'turtle'; }
        return __generator(this, function (_a) {
            return [2 /*return*/, ky.get(CZNA_AUTHORITIES_RECORD_SKOS(id, format), {
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0',
                        'Accept': SKOS_ACCEPT[format],
                    },
                }).text()];
        });
    });
};
/**
 * CZNA-586 — one page of a record's versions, newest first, each with its changed
 * subfields. `offset` must be a multiple of `limit` (the backend pages by version).
 */
export var getRecordHistory = function (ky, id, offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_AUTHORITIES_RECORD_HISTORY(id, offset, limit), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Direct (admin) update of a published authority record — bypasses the proposal
 * workflow. Calls PUT /czna-authorities/records/{id}; the backend writes a
 * `DIRECT_EDIT` entry to record_history and emits a Solr re-index event.
 *
 * AR-02 alternativní scénář A1.
 */
export var updateRecord = function (ky, id, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.put("".concat(API_PATHS.CZNA_AUTHORITIES_RECORDS, "/").concat(id), {
                headers: getHeaders(),
                json: body,
            }).json()];
    });
}); };
/**
 * TASK-084 — universal soft-delete for any authority record.
 *
 * On success: server returns 204. On 409, the rejection comes with a structured
 * {@link DeleteBlockedResponse} body explaining which FK references block the
 * delete. We parse it into an error object with a `blockingReferences` field so
 * the UI delete dialog can render the refs list + (vocab only) offer redirect.
 */
export var deleteRecord = function (ky, id, comment) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1, blocked;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                // CZNA-1531 (F7) — the reason travels as the body; an authority record is not cancelled
                // without one, a vocabulary term may be.
                return [4 /*yield*/, ky.delete(CZNA_AUTHORITIES_RECORD_DETAIL(id), __assign({ headers: getHeaders() }, (comment ? { json: { comment: comment } } : {})))];
            case 1:
                // CZNA-1531 (F7) — the reason travels as the body; an authority record is not cancelled
                // without one, a vocabulary term may be.
                _a.sent();
                return [3 /*break*/, 4];
            case 2:
                error_1 = _a.sent();
                return [4 /*yield*/, parseBlockingRefsError(error_1)];
            case 3:
                blocked = _a.sent();
                if (blocked) {
                    throw blocked;
                }
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * TASK-084 — PATCH /records/{id}/review. Unified entry-point for the
 * approve / redirect admin actions on a pending vocabulary record.
 */
export var patchReview = function (ky, id, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.patch(CZNA_AUTHORITIES_RECORD_REVIEW(id), {
                headers: getHeaders(),
                json: body,
            }).json()];
    });
}); };
/**
 * TASK-084 — read-only preview of FK reference counts. Used by the redirect
 * dialog to render "N + M references will be rewritten" before the admin
 * confirms. Cheap (two count queries server-side).
 */
export var fetchReferencesCount = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_AUTHORITIES_RECORD_REFERENCES_COUNT(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * TASK-109 (AR-08) — read-only merge preview. Returns reference counts +
 * source/target metadata for the side-by-side confirm dialog. No DB side effects.
 */
export var fetchMergePreview = function (ky, sourceId, targetId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_AUTHORITIES_RECORD_MERGE_PREVIEW(sourceId, targetId), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * TASK-109 (AR-08) — merge the source record into the target. The source
 * transitions to MERGED and its FK references are redirected to the target.
 * On 409/422 the ky error carries a {@link MergeConflictResponse} body; callers
 * inspect `error.response` to extract the stable `code`.
 */
export var mergeRecord = function (ky, sourceId, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(CZNA_AUTHORITIES_RECORD_MERGE(sourceId), {
                headers: getHeaders(),
                json: body,
            }).json()];
    });
}); };
